import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { OperationHistory } from '../../../recurringTasks/components/OperationHistory';

interface ContractorRecurringTaskDrawerProps {
    taskId: number;
    projectId: string | undefined;
}

export const ContractorRecurringTaskDrawer: React.FC<ContractorRecurringTaskDrawerProps> = ({
    taskId,
    projectId,
}) => {
    if (!projectId) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
            >
                <Typography>Project ID not available</Typography>
            </Box>
        );
    }

    return (
        <Box height="100%" display="flex" flexDirection="column">
            <OperationHistory projectId={projectId} activityId={String(taskId)} />
        </Box>
    );
};
